export default __webpack_public_path__ + "static/media/logo-crediautos.026b45e1.svg";